export const publications = [
  {
    id: 'iranian-vehicle-dataset-yolov8',
    articleSlug: 'iranian-vehicle-dataset-yolov8',
    officialTitle: 'Iranian Vehicle Images Dataset for Object Detection Algorithm',
    doi: '10.22044/jadm.2024.13858.2501',
    publishedDate: '2024',
    year: 2024,
    venue: 'Journal of Artificial Intelligence and Data Mining (JAIDM), 12(1), 127–136',
    type: 'Journal article',
    citationCount: null,
    authors: ['Pouria Maleki', 'Abbas Ramazani', 'Hassan Khotanlou', 'Sina Ojaghi'],
    paperUrl: 'https://jad.shahroodut.ac.ir/article_3164.html',
    githubUrl: 'https://github.com/pouria-maleki/Iranian-Vehicle-images-dataset-for-detection'
  },
  {
    id: 'vehicle-detection-yolo-emergency-vehicles',
    articleSlug: 'vehicle-detection-yolo-emergency-vehicles',
    officialTitle: 'Object Detection for Vehicles with Yolo',
    doi: '10.1109/SAMI60510.2024.10432884',
    publishedDate: '2024-01-25',
    year: 2024,
    venue: '2024 IEEE 22nd World Symposium on Applied Machine Intelligence and Informatics (SAMI)',
    type: 'IEEE conference paper',
    citationCount: null,
    authors: ['Pouria Maleki', 'Abbas Ramazani', 'Hassan Khotanlou', 'Sina Ojaghi', 'Milad Mousavi', 'Alexey Kalinin', 'Amir Mosavi'],
    paperUrl: 'https://ieeexplore.ieee.org/document/10432884',
    githubUrl: 'https://github.com/pouria-maleki/TVD-dataset'
  },
  {
    id: 'flood-risk-machine-learning',
    articleSlug: 'flood-risk-machine-learning',
    officialTitle: 'Flood Risk Analysis with Deep Learning',
    doi: '10.1109/SISY62279.2024.10737603',
    publishedDate: '2024-09-19',
    year: 2024,
    venue: '2024 IEEE 22nd International Symposium on Intelligent Systems and Informatics (SISY)',
    type: 'IEEE conference paper',
    citationCount: null,
    authors: ['Saba Salmani Ghanbari', 'Bahram Choubin', 'Milad Mousavi', 'Pouria Maleki', 'Amir Mosavi'],
    paperUrl: 'https://ieeexplore.ieee.org/document/10737603'
  },
  {
    id: 'sustainable-energy-fuzzy-control',
    articleSlug: 'sustainable-energy-fuzzy-control',
    officialTitle: 'Sustainable Energy Management in Multi-Unite Cooling Systems With Fuzzy Logic and Adaptive Nonlinear Control',
    doi: '10.1109/ICCIA61416.2023.10506386',
    publishedDate: '2023',
    year: 2023,
    venue: '2023 9th International Conference on Control, Instrumentation and Automation (ICCIA)',
    type: 'IEEE conference paper',
    citationCount: null,
    authors: ['Mohammad Soofi', 'Niloufar Maleki', 'Hadi Delavari', 'Pouria Maleki'],
    paperUrl: 'https://ieeexplore.ieee.org/document/10506386'
  },
  {
    id: 'offline-voice-detection-smart-homes',
    articleSlug: 'offline-voice-detection-smart-homes',
    officialTitle: 'Offline voice detection in smart homes',
    publishedDate: '2023',
    year: 2023,
    venue: '4th International Conference on Electrical Engineering, Computer, Mechanics and Artificial Intelligence',
    type: 'Conference paper',
    citationCount: null,
    authors: ['Sina Ojaghi', 'Javid Ghafourian', 'Pouria Maleki', 'Atefeh Hedayatnia'],
    paperUrl: 'https://www.researchgate.net/publication/375910479_Offline_voice_detection_in_smart_homes'
  }
]

export const thesis = {
  id: 'msc-traffic-control',
  articleSlug: 'deep-reinforcement-learning-traffic-signals',
  officialTitle: 'An Intelligent Traffic Light Control System Using Deep Neural Networks',
  year: 2021,
  institution: 'Bu-Ali Sina University',
  degree: 'M.S. in Electrical Engineering — Control Systems'
}
